module.exports = __webpack_public_path__ + "static/grdf-24eaff3256285131fcc4b5c55c94b2fd.png";